/**
 * Shipping Rates Calculator for Shopify Cart Page
 * Safe, Error-Free, Production Ready
 */

/* ------------------------------
   Countries Province Label Fix
--------------------------------*/
if (typeof Countries === "object") {
  Countries.updateProvinceLabel = function (country, labelEl) {
    if (
      typeof country === "string" &&
      Countries[country] &&
      Countries[country].provinces
    ) {
      if (
        typeof labelEl !== "object" &&
        !(labelEl = document.getElementById("address_province_label"))
      ) {
        return;
      }

      labelEl.innerHTML = Countries[country].label;

      var wrapper = jQuery(labelEl).parent();
      var box = wrapper.find(".custom-style-select-box-inner");

      if (box.length) {
        box.html(Countries[country].provinces[0]);
      }
    }
  };
}

/* ------------------------------
   Shopify Cart Namespace
--------------------------------*/
if (typeof Shopify.Cart === "undefined") {
  Shopify.Cart = {};
}

/* ------------------------------
   Country Province Selector (SAFE)
--------------------------------*/
Shopify.CountryProvinceSelector = function (countryId, provinceId, options) {
  this.countryEl = document.getElementById(countryId);
  this.provinceEl = document.getElementById(provinceId);
  this.provinceContainer = document.getElementById(
    (options && options.hideElement) || provinceId
  );

  if (!this.countryEl || !this.provinceEl) return;

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.addListener = function (target, eventName, callback) {
  if (!target) return;
  target.addEventListener(eventName, callback);
};

/* ------------------------------
   Shipping Calculator Module
--------------------------------*/
Shopify.Cart.ShippingCalculator = (function () {
  var _config = {
    submitButton: "Calculate shipping",
    submitButtonDisabled: "Calculating...",
    templateId: "shipping-calculator-response-template",
    wrapperId: "wrapper-response",
    customerIsLoggedIn: false,
    moneyFormat: "{{amount}}",
  };

  function _render(data) {
    var template = jQuery("#" + _config.templateId);
    var wrapper = jQuery("#" + _config.wrapperId);

    if (!template.length || !wrapper.length) return;

    var compiled = Handlebars.compile(jQuery.trim(template.text()));
    var html = compiled(data);
    jQuery(html).appendTo(wrapper);
  }

  function _enableButtons() {
    jQuery(".get-rates")
      .removeAttr("disabled")
      .removeClass("disabled")
      .val(_config.submitButton);
  }

  function _disableButtons() {
    jQuery(".get-rates")
      .attr("disabled", "disabled")
      .addClass("disabled")
      .val(_config.submitButtonDisabled);
  }

  function _getRates(address) {
    jQuery.ajax({
      type: "POST",
      url: "/cart/prepare_shipping_rates",
      data: jQuery.param({ shipping_address: address }),
      success: _pollRates(address),
      error: _onError,
    });
  }

  function _pollRates(address) {
    return function () {
      jQuery.ajax("/cart/async_shipping_rates", {
        dataType: "json",
        success: function (res, status, xhr) {
          if (xhr.status === 200) {
            _onSuccess(res.shipping_rates, address);
          } else {
            setTimeout(_pollRates(address), 500);
          }
        },
        error: _onError,
      });
    };
  }

  function _onError(xhr) {
    _enableButtons();
    jQuery("#estimated-shipping").hide();

    var data = {};
    try {
      data = JSON.parse(xhr.responseText);
    } catch (e) {}

    var msg =
      data.message ||
      "We are unable to calculate shipping for this address.";

    _render({
      rates: [],
      errorFeedback: msg,
      success: false,
    });

    jQuery("#" + _config.wrapperId).show();
  }

  function _onSuccess(rates, address) {
    _enableButtons();

    var location = "";
    if (address.zip) location += address.zip + ", ";
    if (address.province) location += address.province + ", ";
    location += address.country;

    _render({
      rates: rates,
      address: location,
      success: true,
    });

    jQuery("#" + _config.wrapperId + ", #estimated-shipping").fadeIn();
  }

  function _init() {
    // 🔒 CART PAGE SAFETY
    if (
      !document.getElementById("address_country") ||
      !document.getElementById("address_province")
    ) {
      return;
    }

    new Shopify.CountryProvinceSelector(
      "address_country",
      "address_province",
      { hideElement: "address_province_container" }
    );

    var country = jQuery("#address_country");
    var label = document.getElementById("address_province_label");

    if (typeof Countries !== "undefined" && label) {
      Countries.updateProvinceLabel(country.val(), label);
      country.on("change", function () {
        Countries.updateProvinceLabel(country.val(), label);
      });
    }

    jQuery(".get-rates").on("click", function () {
      _disableButtons();
      jQuery("#" + _config.wrapperId).empty().hide();

      _getRates({
        zip: jQuery("#address_zip").val() || "",
        country: country.val() || "",
        province: jQuery("#address_province").val() || "",
      });
    });

    if (_config.customerIsLoggedIn) {
      jQuery(".get-rates:first").trigger("click");
    }
  }

  return {
    show: function (options) {
      jQuery.extend(_config, options || {});
      jQuery(function () {
        _init();
      });
    },
    getConfig: function () {
      return _config;
    },
  };
})();

/* ------------------------------
   Theme Strings Safe Init
--------------------------------*/
window.theme = window.theme || {};
theme.strings = theme.strings || {};

/* ------------------------------
   Init Shipping Calculator
--------------------------------*/
Shopify.Cart.ShippingCalculator.show({
  submitButton:
    theme.strings.shippingCalcSubmitButton || "Calculate shipping",
  submitButtonDisabled:
    theme.strings.shippingCalcSubmitButtonDisabled || "Calculating...",
  customerIsLoggedIn:
    theme.strings.shippingCalcCustomerIsLoggedIn || false,
  moneyFormat:
    theme.strings.shippingCalcMoneyFormat || "{{amount}}",
});
